import Cookies from "universal-cookie";
import axios from "axios";
import {jwtDecode} from "jwt-decode";
import {getEnvVariable} from '@/utils/helpers';

const cookieName = 'Odeza_agentChatConfigName';
const storagePrefix = 'OdezaAgentChat';

export const AgentChatConfigStoragePath = {
    'default': {
        title: 'Mayo',
        path: 'Mayo/00c7ded1-a590-4d73-b7c7-084b5dfef8dc'
    },
    'ec13db5b-1946-4200-87c0-27cf39cd1092': {
        title: 'Mayo',
        path: 'Mayo/00c7ded1-a590-4d73-b7c7-084b5dfef8dc'
    },
    'bf7d2463-48e4-479d-a358-45ec4a4d79af': {
        title: 'Mayo',
        path: 'Mayo/00c7ded1-a590-4d73-b7c7-084b5dfef8dc'
    },
    'e34fb466-2f9c-46a6-96d3-92e5d9565d2d': {
        title: 'Mayo',
        path: 'Mayo/00c7ded1-a590-4d73-b7c7-084b5dfef8dc'
    },
    '5f8077f2-28a9-4d99-9b84-0880f8afb42c': {
        title: 'Mayo',
        path: 'Mayo/00c7ded1-a590-4d73-b7c7-084b5dfef8dc'
    },
    '55f14620-a0fd-4e32-a571-260680cdcd0e': {
        title: 'Mayo',
        path: 'Mayo/00c7ded1-a590-4d73-b7c7-084b5dfef8dc'
    },
    'da9abc95-f7d8-48d8-a6f5-f730c8ec3982': {
        title: 'Mayo',
        path: 'Mayo/00c7ded1-a590-4d73-b7c7-084b5dfef8dc'
    },
    '79de92f8-e07b-4c0e-bf37-ba467529b1a2': {
        title: 'CHOA',
        path: 'CHOA/25546353-bfd8-4cd4-91da-e53bafc1bb4f'
    },
    'e9f4856e-01e0-449e-8fe1-e106eba9db97': {
        title: 'MBAC',
        path: 'MBAC/2fc7c1cb-bd09-466d-b2d4-8fcc6f7013b5'
    },
    '5d423947-8ae0-4f6c-8e0c-e8a7b394e0e9': {
        title: 'MCT',
        path: 'MCT/386447d9-d0d6-44d3-a89c-a5e43120cf94'
    },
    '347f3faf-0488-4751-8999-13a20d485284': {
        title: 'CHOA',
        path: 'CHOA/c45e2528-fa0a-4743-b39f-3c93464bd058'
    },
    'df58e3a4-c14f-47c2-b08f-06f8167ae2b6': {
        title: 'MGT',
        path: 'MGT/aa3dc48c-2b5c-4058-84b2-1074941b8488'
    },
    'a7c3dca6-f6d0-4778-a0c1-7bb6d9e01dd6': {
        title: 'VJMO',
        path: 'VJMO/bb5268f1-1c5b-46eb-8cd8-ec3b48b6b576'
    },
    'ff0bf33a-ba22-463f-b30c-019c53fdc6b2': {
        title: 'TUHS',
        path: 'TUHS/3cf0d63c-7770-40fd-a321-02169a54cca1'
    },
    '2f7b4496-e0f6-47b7-a951-b2fbf1e94d98': {
        title: 'CRH',
        path: 'CRH/219859a5-7912-4289-a667-832230138bcf'
    },
    '5888551a-c428-423f-9d0c-56304b8d5460': {
        title: 'KN',
        path: 'KN/04fabb20-a509-4503-a5be-c556472e570d'
    },
    'd4cd15f2-3243-4e6b-9b22-437f412922de': {
        title: 'MH',
        path: 'MH/f942bb6a-16b6-43f2-a5f8-1e034b2cfc9e'
    },
    '59a25b7d-5442-4c20-b351-311f7dc0c82a': {
        title: 'TSVAC',
        path: 'TSVAC/d8409d3a-7bba-4307-8879-982d04308498'
    },
    '5a820e1b-47c3-4921-af9b-3cf0fdf20ce1': {
        title: 'CQCH',
        path: 'CQCH/7a97fc8b-b3ea-42cc-87db-c1b5428f252c'
    },
    '72bc7dd5-111f-4b22-8287-d0f7c4f3cb96': {
        title: 'KN',
        path: 'KN/6e030e91-6f46-480b-a112-97bd34bb0b9c'
    },
    '8': {
        title: 'Atrium',
        path: 'Atrium/8a92db7d-a69e-4add-98f1-42911d832e37'
    },
    '14': {
        title: 'Bon Secours & Mercy Health',
        path: 'BSMH/bc92e5d8-4627-47fb-9724-9f56cefe7e4e'
    },
    '18': {
        title: 'Scripps',
        path: 'Scripps/154efe8e-8156-4dcd-b3b5-09a9e112aea2'
    },
    '13': {
        title: 'NCH',
        path: 'NCH/3e785cc9-c17d-4b66-a3cc-16b6d32746df'
    },
    '19': {
        title: 'Nicklaus',
        path: 'Nicklaus/9c68d18e-2395-4a15-a235-4873388cd58b'
    },
    '20': {
        title: 'Fairfield',
        path: 'Fairfield/b3a15743-2035-430b-9172-dde61136bbb4'
    },
    '21': {
        title: 'AHS',
        path: 'AHS/db4dfc62-8957-47e9-91e0-c2825b9639f4'
      },
    '22': {
        title: 'BH',
        path: 'BH/a62bfd50-1e90-4123-a89c-499b5f60366f'
    },
    '10': {
        title: 'Ballad Health',
        path: 'BaH_RSFH/938bd856-7171-4411-ba4c-254a237b0eb6'
    },
    '16': {
        title: 'Roper St. Francis Healthcare',
        path: 'BaH_RSFH/938bd856-7171-4411-ba4c-254a237b0eb6'
    },
    '12': {
        title: 'CH',
        path: 'TCHHN_CH/eda5161e-59b5-4a47-a7eb-cb43a06e912b'
    },
    '24': {
        title: 'TCHHN',
        path: 'TCHHN_CH/eda5161e-59b5-4a47-a7eb-cb43a06e912b'
    },
    '80000000': {
        title: '---',
    },
    '80000002': {
        title: 'AC_UAT',
        path: 'UAT/e585dd55-956d-4bfc-a886-2cd18600d919'
    },
    '80000003': {
        title: 'AC_Demo',
        path: 'AC_Demo/729d490e-6814-49db-9a97-011a303765f4'
    }
}

export const getClientsList = (endpoint) => {
    return new Promise((resolve, reject) => {
        if (!endpoint) {
            return resolve({});
        }
        axios.get(endpoint, {
            headers: {
                'x-api-key': getEnvVariable('amazon_api_key'),
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                try {
                    let data = response.data;
                    if (typeof data !== 'object') {
                        data = JSON.parse(data);
                    }
                    resolve(data);
                } catch (e){
                    reject('Wrong list format. Error:' + e.message);
                }
            })
            .catch(() => reject('Can\'t get list'));
    });
};

export const getAgentChatConfigFromStorage = (clientId) => {
    const path = AgentChatConfigStoragePath[clientId]?.path;
    return new Promise((resolve, reject) => {
        if (!path) {
            return reject('Unknown Organization ID');
        }
        axios.get(getEnvVariable('amazon_config_storage_url') + path + '?' + Math.random(), {
            headers: {
                'x-api-key': getEnvVariable('amazon_api_key'),
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                try {
                    let data = response.data;
                    if (typeof data !== 'object') {
                        data = JSON.parse(data);
                    }
                    resolve(data);
                } catch (e){
                    reject('Wrong AgentChat configuration format. Error:' + e.message);
                }
            })
            .catch(() => reject('Can\'t get configuration for AgentChat'));
    });
};

export const getAgentChatConfigFromAPI = (endpoint, clientId) => {
    return new Promise((resolve, reject) => {
        axios.get(endpoint + `/clients/${clientId}/config/agent-chat`, {
            headers: {
                'x-api-key': getEnvVariable('amazon_api_key'),
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                try {
                    let data = response.data;
                    if (typeof data !== 'object') {
                        data = JSON.parse(data);
                    }
                    resolve(data);
                } catch (e){
                    reject('Wrong AgentChat configuration format. Error:' + e.message);
                }
            })
            .catch(() => reject('Can\'t get configuration for AgentChat'));
    });
};

export const getAgentChatConfigName = () => {
    const cookies = new Cookies();
    return cookies.get(cookieName);
}

export const setAgentChatConfigName = (configName) => {
    const cookies = new Cookies();
    cookies.set(cookieName, configName, {path: '/', sameSite: 'strict'});
}

export const loadAgentChatConfigParams = () => {
    return {
        env: sessionStorage.getItem(storagePrefix + "Env"),
        clientId: sessionStorage.getItem(storagePrefix + "Client")
    };
}

export const saveAgentChatConfigParams = (env, clientId) => {
    sessionStorage.setItem(storagePrefix + "Env", env);
    sessionStorage.setItem(storagePrefix + "Client", clientId);
}

export const getAgentChatToken = () => {
    const token = sessionStorage.getItem(storagePrefix + 'Token');
    try {
        const jwtDecoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (jwtDecoded.exp < currentTime) {
            throw "Agent token expired";
        }
    } catch (e) {
        return null;
    }
    return token;
}

export const setAgentChatToken = (token) => {
    sessionStorage.setItem(storagePrefix + 'Token', token);
}

/* // Not Used
export const generateLoginUrl = (redirectUrl, instanceId) => {
    return 'https://odeza.auth0.com/authorize?client_id=' + getEnvVariable('auth0_client_id') +
        '&response_type=code' +
        '&connection=Username-Password-Authentication' +
        '&scope=openid%20profile%20email' +
        '&redirect_uri=' + redirectUrl + '/agent/auth%3Fprovider=auth0%26old=1%26instance_id=' + instanceId;
}
*/

export const getProviderAuthTokenFromURL = (providerAuthUrl) => {
    const parsedUrl = new URL(providerAuthUrl);
    let token = parsedUrl.searchParams.get('token'); // JWT
    if (!token) {
        token = parsedUrl.searchParams.get('access_token'); // Auth0
    }
    return token;
}
